import { $t } from '@/i18n';
export const jobSchema = {
    type: 'object',
    id: 'job',
    title: $t('k_b729fdd7'),
    fields: [
        { id: 'id', type: 'string', title: $t('k_52092425') },
        { id: 'title', type: 'string', title: $t('k_44b560ad') },
        { id: 'status', type: 'string', title: $t('k_9381362e') },
        { id: 'params', type: 'object', title: $t('k_33d28a3d'), fields: [] },
        { id: 'state', type: 'object', title: $t('k_ea69e7ef'), fields: [] },
        { id: 'nodes', type: 'object', title: $t('k_f6148a12'), fields: [] },
        { id: 'message', type: 'string', title: $t('k_fa8ec205') },
        { id: 'creator', type: 'string', title: $t('k_66ca76fd') },
        { id: 'currentApprovers', type: 'string', title: $t('k_c279a045') },
        { id: 'relatedUsers', type: 'string', title: $t('k_36dc214a') },
        { id: 'flowId', type: 'string', title: $t('k_eb51ec65') },
        { id: 'ctime', type: 'string', title: $t('k_f185b9aa') },
        { id: 'envId', type: 'string', title: $t('k_740ff4b6') },
        { id: 'url', type: 'string', title: $t('k_1562a2e0') },
        {
            id: 'detailBlocks', type: 'array', title: $t('k_88d94282'),
            items: {
                type: 'object',
                fields: [
                    { id: 'title', type: 'string', title: $t('k_b4fb734e') },
                    { id: 'ctime', type: 'number', title: $t('k_e80e44f6') },
                    { id: 'nodeId', type: 'string', title: $t('k_7dde8972') },
                    { id: 'type', type: 'string', title: $t('k_c7a47147') },
                    // { id: 'nodePagelet', type: 'string', title: '对应页面片ID' },
                ],
            },
        },
        {
            id: 'reload', type: 'methods', title: $t('k_72c30a28'),
        },
        {
            id: 'isWaitingForNextBlock', type: 'boolean', title: $t('k_33da2838'),
        },
    ],
};
